var React = require('react');

function ClearInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.414 8l2-2L10 4.586l-2 2-2-2L4.586 6l2 2-2 2L6 11.414l2-2 2 2L11.414 10l-2-2zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16z","fill":"currentColor","fillRule":"evenodd"}));
}

ClearInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ClearInline;

ClearInline.default = ClearInline;
